import { useTranslations } from 'next-intl';
import React from 'react';
import {
  ModalRoot,
  ModalContainer,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@mentimeter/ragnar-ui/modal';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Link } from '@mentimeter/ragnar-ui/link';
import { Button } from '@mentimeter/ragnar-ui/button';
import { EXPOSED_CREDENTIALS_HELP_ARTICLE_URL } from '../../clientErrorMessages';
const BoldText = (chunks: React.ReactNode) => {
  return <Text fontWeight="semiBold">{chunks}</Text>;
};
export const ExposedCredentialsLoginError = () => {
  const [open, setOpen] = React.useState(true);
  const t = useTranslations('authentication.reset_password');

  return (
    <ModalRoot open={open} onOpenChange={setOpen}>
      <ModalContainer size="small">
        <ModalHeader>{t('reset_password_heading')}</ModalHeader>
        <ModalBody>
          <Text>
            {t.rich('exposed_credentials_message_change_password', {
              BoldText,
            })}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Link
            underline={false}
            href={EXPOSED_CREDENTIALS_HELP_ARTICLE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('learn_more_link')}
          </Link>
          <Button href="/auth/reset_passwords" variant="primary">
            {t('reset_password_button')}
          </Button>
        </ModalFooter>
      </ModalContainer>
    </ModalRoot>
  );
};
